<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <!--Data Table-->
        <v-data-table
          :headers="headers"
          :items="arrayList"
          :search="search"
          :single-select="true"
          class="elevation-1"
        >
          <template v-slot:item.opciones="{ item }">
            <v-icon v-if="deuda" small class="mr-2" @click="editItem(item)"
              >edit
            </v-icon>
            <v-tooltip bottom>
              <template v-if="transacciones" v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="verDetalle(item)"
                  >tab</v-icon
                >
              </template>
              <span>Ver detalle</span>
            </v-tooltip>
          </template>
          <template v-if="deuda" v-slot:item.nombre="{ item }">
            <span class="blue--text">{{ item.nombre }}</span>
          </template>
          <template v-if="deuda" v-slot:item.deuda="{ item }">
            <span class="blue--text">{{ item.deuda }}</span>
          </template>
          <!-- <template v-if="deuda" v-slot:item.deuda="{ item }">
            <span v-if="(item.deuda > 0)" class="red--text">{{item.deuda}}</span>
            <span v-else class="blue--text">{{item.deuda}}</span>
          </template> -->
          <template v-if="transacciones" v-slot:item.persona="{ item }">
            <span class="blue--text">{{ clientesAutocomplete(item.persona) }}</span>
          </template>
          <template v-if="transacciones" v-slot:item.total="{ item }">
            <span class="blue--text">{{item.total }}</span>
          </template>
          <template v-if="transacciones" v-slot:item.pagado="{ item }">
            <span v-if="(item.pagado < item.total)" class="red--text">{{item.pagado}}</span>
            <span v-else class="green--text">{{item.pagado}}</span>
          </template>
          <template v-if="transacciones" v-slot:item.monto="{ item }">
            <span v-if="(item.pagado < item.total)" class="red--text">{{item.monto}}</span>
            <span v-else class="green--text">{{item.monto}}</span>
          </template>
          <template v-if="transacciones" v-slot:item.deuda="{ item }">
            <span v-if="(item.deuda == 0)" class="blue--text">{{item.deuda}}</span>
            <span v-else class="red--text">{{item.deuda}}</span>
          </template>
          <template v-if="transacciones" v-slot:item.fecha="{ item }">
            <span v-if="item.fecha" class="blue--text">{{item.fecha}}</span>
            <span v-else class="orange--text">{{item.createdAt}}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Table",
  data() {
    return {
      itemObj: {
        id: "",
        nombre: "",
        deuda: "",
        token: "",
      },
      personaObj: {
        id: "",
        deuda: "",
        token: "",
      },
    };
  },
  props: {
    headers: Array,
    arrayList: Array,
    search: "",
    select: "",
    deuda: {
      type: Boolean,
      default: false,
    },
    transacciones: {
      type: Boolean,
      default: false,
    },
  },
  created() {
  },
  computed: {
    ...mapState("usuarioNamespace", ["token"]),
    ...mapState("clienteNamespace", ["clientes"]),
  },
  methods: {
    clientesAutocomplete(id) {
      let clientes = this.clientes;
      let nombre = '';
      clientes.forEach(element => {
        if(element._id == id) {
          nombre = element.nombre
        }
      });
      return nombre;
    },
    editItem(item) {
      this.itemObj.id = item._id;
      this.itemObj.nombre = item.nombre;
      this.itemObj.deuda = item.deuda;
      this.itemObj.token = this.token;
      this.$emit("edit", this.itemObj);
    },
    verDetalle(item) {
      this.$emit("detalle", item);
    },
  },
};
</script>
